import { render, staticRenderFns } from "./situationGlobalIndex.vue?vue&type=template&id=5037feb0&scoped=true"
import script from "./situationGlobalIndex.vue?vue&type=script&lang=js"
export * from "./situationGlobalIndex.vue?vue&type=script&lang=js"
import style0 from "./situationGlobalIndex.vue?vue&type=style&index=0&id=5037feb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037feb0",
  null
  
)

export default component.exports